import { render, staticRenderFns } from "./seeProductsModal.vue?vue&type=template&id=6d35ccb4&"
import script from "./seeProductsModal.vue?vue&type=script&lang=js&"
export * from "./seeProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports